import { environmentHttpClient } from "client/Api/httpClient";

export enum ZenyaDocResourceKind
{
	BrowseDocuments = 0,
	Favorites = 1
}

export type ZenyaDocInterests = {
	recentItems?: true;
	favorites?: true;
};

export type ZenyaDocLiveInformationRequestModel = {
	connectionId: number;
	interestedIn: ZenyaDocInterests;
};

export enum ItemsResultStatus {
	GeneralFailure = 0,
	Success = 1,
	EmailAddressRequired = 2
}

export type ZenyaDocContentItem = {
	id: string;
	name: string;
	type: string;
	url: string;
};

export type ZenyaDocRecentItemsResponseModel = {
	status: ItemsResultStatus;
	page: PageResult<ZenyaDocContentItem>;
};

export type ZenyaDocFavoriteItem = {
	id: number;
	name: string;
	url: string;
};

export type ZenyaDocFavoritesResponseModel = {
	status: ItemsResultStatus;
	items: readonly ZenyaDocFavoriteItem[];
};

export type ZenyaDocLiveInformationResponseModelData = {
	recentItems?: ZenyaDocRecentItemsResponseModel;
	favorites?: ZenyaDocFavoritesResponseModel;
};

export enum ZenyaDocResultKind {
	Success = 0,
	EmailAddressRequired = 1
};

export type ZenyaDocLiveInformationResponseModel = {
	connectionId: number;
	interests: ZenyaDocInterests;
	data: ZenyaDocLiveInformationResponseModelData;
};

export type ListZenyaDocPortalsResponseModel = {
	resultKind: ZenyaDocResultKind.Success;
	portals: readonly ZenyaDocPortal[];
} | {
	resultKind: ZenyaDocResultKind.EmailAddressRequired;
	portals: null;
};

export type ZenyaDocPortal = {
	id: number;
	name: string;
};

const CONTROLLER_BASE_PATH = "/Workspace/LiveInformation/ZenyaDoc";

export function getLiveInformation(
	requests: ZenyaDocLiveInformationRequestModel[]
): Promise<readonly ZenyaDocLiveInformationResponseModel[]> {
	return environmentHttpClient.post<readonly ZenyaDocLiveInformationResponseModel[]>(
		CONTROLLER_BASE_PATH,
		requests
	);
};

export function deleteFavorite(
	connectionId: number,
	favoriteId: number,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.delete<void>(
		`${CONTROLLER_BASE_PATH}/Connections/${connectionId}/Favorites/${favoriteId}`,
		null,
		{signal}
	);
}

export function listPortals(connectionId: number): Promise<readonly ZenyaDocPortal[]> {
	return environmentHttpClient.get<readonly ZenyaDocPortal[]>(
		`${CONTROLLER_BASE_PATH}/Connections/${connectionId}/Portals`,
	);
}

export function search(
	connectionId: number,
	portalId: number | null,
	searchTerm: string,
	page: number,
	signal: AbortSignal
): Promise<PageResult<ZenyaDocContentItem>>
{
	return environmentHttpClient.get<PageResult<ZenyaDocContentItem>>(
		`${CONTROLLER_BASE_PATH}/Connections/${connectionId}/Search`,
		{
			searchTerm,
			portalId,
			page
		},
		{ signal }
	);
}

export function addFavorite(
	connectionId: number,
	contentItemId: string,
	name: string,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.post<void>(
		`${CONTROLLER_BASE_PATH}/Connections/${connectionId}/Favorites/`,
		{
			contentItemId,
			name
		},
		{ signal }
	);
};
